var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-form-item',{attrs:{"label":_vm.label}},_vm._l((_vm.imgs),function(img,index){return _c('span',{key:index},[_c('el-image',{staticClass:"style-img",attrs:{"src":img,"preview-src-list":_vm.srcList}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }